import React, { createContext, useContext } from "react";
import { useKitchenNow } from "../TimedOrderCard";
import { getItemTiming } from "../../itemTiming";

const DishUrgency = createContext(null);
const number = (value) => new Intl.NumberFormat().format(value);

// Tick only the card boundary and its timing label, not all order breakdowns,
// images, draft controls or confirmation state in the item-wise view.
export default function TimedDishCard({ entries, panelId, children }) {
  const timing = getItemTiming(entries, useKitchenNow());
  return (
    <article className={`item-wise-dish item-wise-dish--${panelId} item-wise-dish--timing-${timing.tone}`}>
      <DishUrgency.Provider value={timing}>{children}</DishUrgency.Provider>
    </article>
  );
}

export function DishTiming() {
  const timing = useContext(DishUrgency);
  if (!timing) return null;
  const deadline = timing.display && timing.display !== "—" ? timing.display : "";
  return (
    <span className={`item-wise-timing item-wise-timing--${timing.tone}`} title={timing.description}>
      <span className="item-wise-timing-mark" aria-hidden="true" />
      {timing.label}{deadline ? ` · ${deadline}` : ""}
      {timing.overdueQty > 0 && <span> · {number(timing.overdueQty)} overdue</span>}
      {timing.unknownQty > 0 && <span className="item-wise-timing-unknown"> · {number(timing.unknownQty)} timing unknown</span>}
    </span>
  );
}
